import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'vpfe-side-nav-carrier',
  templateUrl: './side-nav-carrier.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavCarrierComponent {}
